export default "__VITE_ASSET__bdee231c__"